<template>
  <span v-if="params.passed" class="material-icons text-ok mr-2" style="line-height: 1.4rem">thumb_up</span>
  <span v-else class="material-icons text-ko mr-2" style="line-height: 1.4rem">thumb_down</span>
</template>
<script lang="ts">
export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    }
  },
};
</script>
